import { PropsWithChildren } from 'react';

import { useQuery, gql } from '@apollo/client';
import { Groups, AccountTree, Timer } from '@mui/icons-material';
import {
  // useTournamentChallengeDelete,
  useTranslation,
} from '@scorenco/core';
import { useRouter } from 'next/router';

import { AdminDjango } from '@/components';
import { useCurrentClubContext } from '@/layouts';
import { T_KEYS } from '@/translations';

import { TournamentsLayoutComponent } from '../../../../../_internal/TournamentsLayout/TournamentsLayoutComponent';

export type ChallengeLayoutComponentProps = PropsWithChildren<{
  additionalMenus?: JSX.Element;
}>;

export const ChallengeLayoutComponent = ({
  children,
}: ChallengeLayoutComponentProps) => {
  const router = useRouter();
  const { t } = useTranslation();
  const { currentClub } = useCurrentClubContext();
  // const deleteTournamentChallenge = useTournamentChallengeDelete();

  const getChallengeName = useQuery(
    gql`
      query GetChallengeName($challengeId: Int!) {
        tournaments_challenge_by_pk(id: $challengeId) {
          id
          name
          color
          gender
          age_category
          tournament {
            id
            name
          }
        }
      }
    `,
    {
      variables: {
        challengeId: Number(router.query.challengeId),
      },
      skip: !router.query.challengeId,
      context: {
        role: 'club',
      },
    }
  );

  return (
    <>
      <AdminDjango
        service="tournaments"
        table="challenge"
        id={router.query.challengeId}
      />
      <TournamentsLayoutComponent
        challenge={getChallengeName?.data?.tournaments_challenge_by_pk}
        challengeMenu={[
          {
            label: t(T_KEYS.TEAMS_TITLE),
            href: `/${currentClub.id}/tournaments/${router.query.tournamentId}/challenges/${router.query.challengeId}/teams`,
            icon: <Groups />,
          },
          {
            label: t(T_KEYS.TOURNAMENTS_CHALLENGE_RULES_SECTION_LABEL),
            href: `/${currentClub.id}/tournaments/${router.query.tournamentId}/challenges/${router.query.challengeId}/rules`,
            icon: <AccountTree />,
          },
          {
            label: t(T_KEYS.TOURNAMENTS_CHALLENGE_PLANNING_SECTION_LABEL),
            href: `/${currentClub.id}/tournaments/${router.query.tournamentId}/challenges/${router.query.challengeId}`,
            icon: <Timer />,
          },
        ]}
      >
        {children}
      </TournamentsLayoutComponent>
    </>
  );
};
